module.exports = "/_next/static/images/diabets_BI-563290c8d911757007309128fb1b1793.png";